// src/js/reducers/index.js
import * as types from "../constants/action-types";
import moment from 'moment';
import { adjustForBST } from '../utils/timeHelper';

function compare(a, b) {
    
    // Use toUpperCase() to ignore character casing
    const genreA = a.totalTime;//.toUpperCase();
    const genreB = b.totalTime;//.toUpperCase();
  
    let comparison = 0;
    if (genreA < genreB) {
      comparison = 1;
    } else if (genreA > genreB) {
      comparison = -1;
    }
    return comparison;
  }
 
  
export default function registerReducer(state = { register: [], selected: {}, matchingPersonnel: []}, action) {

    if (action.register && action.register.length > 0) {
        action.register.forEach(function(item) {
            item.dteSignIn = adjustForBST(item.dteSignIn);
        })
    }

    switch (action.type) {
        case types.LOGOUT:
            return []
        case types.SIGNIN_SUCCESS: 
            var result = Object.assign({}, state);
            result.register = [...state.register.filter(register => register.registerId !== action.register.registerId), 
                Object.assign({}, action.register)];
            result.register = result.register.sort(compare);
            result.selected = action.register;
            return result;
        
        case types.SIGNOUT_SUCCESS:
            var result = Object.assign({}, state); 
            result.register = [...state.register.filter(register => register.personnelId !== action.register.personnelId && register.projectId !== action.register.projectId), 
                Object.assign({}, action.register)];
            result.register = result.register.sort(compare);   
            result.selected = action.register;   
            return result;
        
        case types.SIGNOUTALL_SUCCESS:
            var result = Object.assign({}, state); 
            var t = result.register;
            

            action.register.forEach(element => {
                t = [...t.filter(register => register.personnelId !== element.personnelId && register.projectId !== element.projectId),
                    Object.assign({}, element)];    
            });
            
            result.register = t.sort(compare);   
            result.selected = {};   

            return result;
        
        case types.LOAD_REGISTER_SUCCESS:
            
            var result = Object.assign({}, state); 

            if(action.register.length > 0) 
                result.register = action.register.sort(compare);
            else
                result.register = action.register;

            return result;
            
        case types.LOAD_SIGNINPERSONNEL_SUCCESS:
            var result = Object.assign({}, state);
            console.log(action)
            result.matchingPersonnel = action.person;
          
            return result;
                
        case types.LOAD_SIGNIN_SUCCESS:
            var result = Object.assign({}, state);
            console.log(action)
            if (action.register.length > 0)
                result.selected = action.register[0];
            else
                result.selected = action.register;

            return result;
        
       default:
            return state
    };
};
